import axios from "axios"
import API from '@s/API'
import _indexOf from 'lodash/indexOf'

const Utils = {
    sha1(msg) {

        var blockstart;
        var i, j;
        var W = new Array(80);
        var H0 = 0x67452301;
        var H1 = 0xEFCDAB89;
        var H2 = 0x98BADCFE;
        var H3 = 0x10325476;
        var H4 = 0xC3D2E1F0;
        var A, B, C, D, E;
        var temp;
        msg = this._Utf8Encode(msg);
        var msg_len = msg.length;
        var word_array = new Array();
        for (i = 0; i < msg_len - 3; i += 4) {
            j = msg.charCodeAt(i) << 24 | msg.charCodeAt(i + 1) << 16 |
                msg.charCodeAt(i + 2) << 8 | msg.charCodeAt(i + 3);
            word_array.push(j);
        }
        switch (msg_len % 4) {
            case 0:
                i = 0x080000000;
                break;
            case 1:
                i = msg.charCodeAt(msg_len - 1) << 24 | 0x0800000;
                break;
            case 2:
                i = msg.charCodeAt(msg_len - 2) << 24 | msg.charCodeAt(msg_len - 1) << 16 | 0x08000;
                break;
            case 3:
                i = msg.charCodeAt(msg_len - 3) << 24 | msg.charCodeAt(msg_len - 2) << 16 | msg.charCodeAt(msg_len - 1) << 8 | 0x80;
                break;
        }
        word_array.push(i);
        while ((word_array.length % 16) != 14) word_array.push(0);
        word_array.push(msg_len >>> 29);
        word_array.push((msg_len << 3) & 0x0ffffffff);
        for (blockstart = 0; blockstart < word_array.length; blockstart += 16) {
            for (i = 0; i < 16; i++) W[i] = word_array[blockstart + i];
            for (i = 16; i <= 79; i++) W[i] = this._rotate_left(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
            A = H0;
            B = H1;
            C = H2;
            D = H3;
            E = H4;
            for (i = 0; i <= 19; i++) {
                temp = (this._rotate_left(A, 5) + ((B & C) | (~B & D)) + E + W[i] + 0x5A827999) & 0x0ffffffff;
                E = D;
                D = C;
                C = this._rotate_left(B, 30);
                B = A;
                A = temp;
            }
            for (i = 20; i <= 39; i++) {
                temp = (this._rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0x6ED9EBA1) & 0x0ffffffff;
                E = D;
                D = C;
                C = this._rotate_left(B, 30);
                B = A;
                A = temp;
            }
            for (i = 40; i <= 59; i++) {
                temp = (this._rotate_left(A, 5) + ((B & C) | (B & D) | (C & D)) + E + W[i] + 0x8F1BBCDC) & 0x0ffffffff;
                E = D;
                D = C;
                C = this._rotate_left(B, 30);
                B = A;
                A = temp;
            }
            for (i = 60; i <= 79; i++) {
                temp = (this._rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0xCA62C1D6) & 0x0ffffffff;
                E = D;
                D = C;
                C = this._rotate_left(B, 30);
                B = A;
                A = temp;
            }
            H0 = (H0 + A) & 0x0ffffffff;
            H1 = (H1 + B) & 0x0ffffffff;
            H2 = (H2 + C) & 0x0ffffffff;
            H3 = (H3 + D) & 0x0ffffffff;
            H4 = (H4 + E) & 0x0ffffffff;
        }
        var temp = this._cvt_hex(H0) + this._cvt_hex(H1) + this._cvt_hex(H2) + this._cvt_hex(H3) + this._cvt_hex(H4);

        return temp.toLowerCase();

    },

    _rotate_left(n, s) {
        var t4 = (n << s) | (n >>> (32 - s));
        return t4;
    },
    _lsb_hex(val) {
        var str = "";
        var i;
        var vh;
        var vl;
        for (i = 0; i <= 6; i += 2) {
            vh = (val >>> (i * 4 + 4)) & 0x0f;
            vl = (val >>> (i * 4)) & 0x0f;
            str += vh.toString(16) + vl.toString(16);
        }
        return str;
    },
    _cvt_hex(val) {
        var str = "";
        var i;
        var v;
        for (i = 7; i >= 0; i--) {
            v = (val >>> (i * 4)) & 0x0f;
            str += v.toString(16);
        }
        return str;
    },
    _Utf8Encode(string) {
        string = string.replace(/\r\n/g, "\n");
        var utftext = "";
        for (var n = 0; n < string.length; n++) {
            var c = string.charCodeAt(n);
            if (c < 128) {
                utftext += String.fromCharCode(c);
            }
            else if ((c > 127) && (c < 2048)) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            }
            else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }
        }
        return utftext;
    }
}


const state = {
    authenticated: false,
    key: null,
    accessToken: null,
    refreshToken: null,
    user: null,
    hash: '',
    permissions: [],
    roles: []

}

const getters = {
    isAuthenticated: state => {
        return state.authenticated
    },
    key: state => {
        return state.key
    },
    accessToken: state => {
        return state.accessToken
    },
    refreshToken: state => {
      return state.refreshToken
    },
    user: state => {
        return state.user
    },
    hash: state => {
        return state.hash
    },
    permissions: state => {
        return state.permissions
    },
    roles: state => {
        return state.roles
    },
    can: state => {

        return permissions => {


            var temp,
                tKey,
                obj = state.permissions,
                multipart = [];


            if (obj) {

                if (permissions.indexOf('||') !== -1) {
                    multipart = permissions.split(' || ');
                }
                else {
                    multipart.push(permissions);
                }


                var oneOk = false;

                for (var mKey in multipart) {
                    if (_indexOf(obj, multipart[mKey]) != -1) {
                        oneOk = true;
                    }
                }

                if (oneOk !== true) {
                    return false
                }
                else {
                    return true
                }


            }
        }
    }

}

const mutations = {
    authenticated(state, payload) {
        state.authenticated = payload
    },
    key(state, payload) {
      state.key = payload
    },
    accessToken(state, payload) {
        state.accessToken = payload
    },
    SET_REFRESH_TOKEN(state, payload) {
        state.refreshToken = payload
    },
    user(state, payload) {
        if (payload.type == 'users') {
            state.hash = Utils.sha1('user', payload.user.iduser)
        }
        else if (payload.type == 'internals') {
            state.hash = Utils.sha1('internal', payload.user.id)
        }
        else {
            throw('Type d\'utilisateur inconnu');
        }

        state.user = payload
    },
    permissions(state, payload) {
        state.permissions = payload
    },
    roles(state, payload) {
        state.roles = payload
    },
    logout(state) {
        state.authenticated = false;
        state.key = null;
        state.accessToken = null;
        state.refreshToken = null;
        state.user = null;
        state.hash = '';
        state.permissions = [];
        state.roles = [];
        window.V.$localStorage.remove('ACCESS_TOKEN');
        window.V.$localStorage.remove('REFRESH_TOKEN');
        delete axios.defaults.headers.Authorization;
        delete axios.defaults.headers.asClient;
    },


}

const actions = {
    login(context, payload) {
        let username = payload.username;
        let password = payload.password;

        return new Promise((resolve, reject) => {
          axios.post(API.endpoints.oauth.login,
            {
                client_id:102,
                client_secret: "vrU9HLqKoovPEsLDDGSN98doTy14zOgTZjp9Xf7g",
                username: username,
                password: password
            },
            { baseURL: API.apiAuthUrl })
                .then(response => {
                    context.commit('authenticated', true);
                    context.commit('key', response.data.key);

                    // store access token
                    context.commit('accessToken', response.data.access_token);
                    window.V.$localStorage.set('ACCESS_TOKEN', response.data.access_token);

                    // store refresh token
                    context.commit('SET_REFRESH_TOKEN', response.data.refresh_token)
                    window.V.$localStorage.set('REFRESH_TOKEN', response.data.refresh_token);

                    axios.defaults.headers.Authorization = 'Bearer ' + response.data.access_token;

                    context.commit('Messages/clearMessages', '', {root: true})

                    resolve(response);
                })
                .catch(e => {
                    if (403 === e.response.status) {
                        context.commit('Messages/addError', "Vous n\'êtes pas autorisé à vous connecter à cette application", {root: true})
                    }
                    reject(e);
                })
        })

    },

    googleLogin(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(API.endpoints.oauth.google, {
                access_token: payload,
                client_secret: "vrU9HLqKoovPEsLDDGSN98doTy14zOgTZjp9Xf7g",
                client_id:102
            })
                .then(response => {
                    context.commit('authenticated', true);
                    context.commit('key', response.data.key);

                    // store access token
                    context.commit('accessToken', response.data.access_token);
                    window.V.$localStorage.set('ACCESS_TOKEN', response.data.access_token);

                    // store refresh token
                    context.commit('SET_REFRESH_TOKEN', response.data.refresh_token)
                    window.V.$localStorage.set('REFRESH_TOKEN', response.data.refresh_token);

                    axios.defaults.headers.Authorization = 'Bearer ' + response.data.access_token;

                    context.commit('Messages/clearMessages', '', {root: true})

                    resolve(response);
                })
                .catch(e => {
                    if (403 === e.response.status) {
                        context.commit('Messages/addError', "Vous n\'êtes pas autorisé à vous connecter à cette application", {root: true})
                    }
                    reject(e);
                })
        })
    },

    logout(context, payload) {
        return axios.post(API.endpoints.oauth.logout, undefined, { baseURL: API.apiAuthUrl })
    },

    checkToken(context, payload) {
        context.commit('UI/loadingProgress', 1, {root: true});
        return new Promise((resolve, reject) => {
            axios.get(API.endpoints.me.me, {
                headers: {'Authorization': 'Bearer ' + payload},
            })
                .then(response => {
                    context.commit('UI/loadingProgress', 34, {root: true});
                    context.commit('authenticated', true);
                    context.commit('key', response.data.key);
                    context.commit('user', {type: response.data.type, user: response.data.me});

                    // store access token
                    context.commit('accessToken', payload);
                    window.V.$localStorage.set('ACCESS_TOKEN', payload);

                    if (axios.defaults.headers.asClient) {
                        sessionStorage.setItem('AS_CLIENT', axios.defaults.headers.asClient);
                    }
                    else if (sessionStorage.getItem('AS_CLIENT')) {
                        axios.defaults.headers.asClient = sessionStorage.getItem('AS_CLIENT');
                    }

                    axios.defaults.headers.Authorization = 'Bearer ' + payload;

                    context.dispatch('fetchPermissions')
                        .then(responseAcl => {
                            if (context.getters.can('global-access-admin')) {
                                context.commit('UI/loadingProgress', 67, {root: true});
                                context.dispatch('Papers/getClientInfos', {}, {root: true})
                                    .then(responseClientInfos => {
                                        context.commit('Messages/clearMessages', '', {root: true})
                                        context.commit('UI/loadingProgress', 100, {root: true});
                                        resolve(response);
                                    })
                            }
                            else {
                                context.commit('Messages/addError', 'Vous n\'avez pas la permission nécessaire pour vous connecter', {root: true})
                                context.commit('logout');

                                window.V._router.push('/login');
                                context.commit('UI/showLoading', false, {root: true});
                            }

                        })


                })
                .catch(e => {
                    //window.V.loginMode = true;
                    context.commit('Messages/clearMessages', '', {root: true})
                    context.commit('logout');
                    reject(e);
                })
        })
    },

    fetchUser(context) {

        return new Promise((resolve, reject) => {
            axios.get(API.endpoints.me.me)
                .then(responseUser => {
                    context.commit('key', responseUser.data.key);
                    context.commit('user', {type: responseUser.data.type, user: responseUser.data.me});
                    resolve(responseUser);
                })
                .catch(e => {
                    reject(e);
                })
        })
    },
    fetchPermissions(context) {
        return axios.get(API.endpoints.me.permissions)
            .then(response => {

                let permissions = [];
                for (let i = 0; i < response.data.permissions.length; i++) {
                    permissions.push(response.data.permissions[i].name);
                }

                context.commit('permissions', permissions)
                context.commit('roles', response.data.roles)
            })
    },

    async retryAuth(context) {
      try {
        const refreshToken = context.getters['Auth/refreshToken'] || localStorage.getItem('REFRESH_TOKEN')

        const response = await axios.post(
          API.endpoints.oauth.refresh,
          {
            refresh_token: refreshToken,
            client_id:102,
            client_secret: "vrU9HLqKoovPEsLDDGSN98doTy14zOgTZjp9Xf7g"
          },
          {
            baseURL: API.apiAuthUrl,
          }
        )

        // store access token
        context.commit('accessToken', response.data.access_token);
        window.V.$localStorage.set('ACCESS_TOKEN', response.data.access_token);

        // store refresh token
        context.commit('SET_REFRESH_TOKEN', response.data.refresh_token)
        window.V.$localStorage.set('REFRESH_TOKEN', response.data.refresh_token);
      } catch (error) {
        console.log(error)
      }
    }

}

const module = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};

export default module;



// WEBPACK FOOTER //
// ./src/stores/modules/authentication/store.js